import { BaseModal } from './BaseModal';
import { ConfirmModal } from './ConfirmModal';
import { DeleteModal } from './DeleteModal';
import { ModalOptions } from './type';

interface Props {
  modal: ModalOptions | null;
  onClose: () => void;
}

export const ModalRoot = ({ modal, onClose }: Props) => {
  if (!modal) return null;

  switch (modal.type) {
    case 'confirm':
      return (
        <ConfirmModal
          open
          title={modal.title}
          description={modal.description}
          onCancel={onClose}
          onConfirm={async () => {
            try {
              await modal.onConfirm();
              onClose();
            } catch {
              // Keep the modal open when confirmation fails.
            }
          }}
        />
      );

    case 'delete':
      return (
        <DeleteModal
          open
          title={modal.title}
          description={modal.description}
          onCancel={onClose}
          onDelete={async () => {
            try {
              await modal.onDelete();
              onClose();
            } catch {
              // Keep the modal open when deletion fails.
            }
          }}
        />
      );

    case 'custom':
      return (
        <BaseModal
          open
          title={modal.title || ''}
          description={modal.description}
          onClose={onClose}
          maxWidth={modal.maxWidth}
          actions={modal.actions}
          closeOnBackdrop={modal.disableClose}
          closeOnEsc={modal.disableClose}
        >
          {modal.content}
        </BaseModal>
      );
    default:
      return null;
  }
};
